"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react2 = _interopRequireDefault(require("@tippyjs/react"));

var Styled = (0, _styledComponents["default"])(_react2["default"]).withConfig({
  displayName: "StyledTippy__Styled",
  componentId: "sc-9z7huw-0"
})(["min-width:125px;.tippy-content{box-sizing:border-box;background-color:#1c273a;padding:10px 8px;font-size:12px;line-height:12px;text-align:center;box-shadow:0px 2px 8px rgba(0,0,0,0.1);color:white;font-weight:700;border-radius:4px !important;}"]);

var StyledTippy = function StyledTippy(props) {
  return /*#__PURE__*/_react["default"].createElement(Styled, (0, _extends2["default"])({}, props, {
    offset: [0, 3]
  }));
};

var _default = StyledTippy;
exports["default"] = _default;